// KİMÖ-453 Kimya ve Teknoloji — Tam Sunum Ders Notları
// Blok tipleri: p, ul, ol, table, box(tone), formula, flow
export const k453Notes = [
  {
    id: "u1",
    no: "Ünite 1",
    title: "Kimya – Teknoloji – Toplum İlişkisi",
    sections: [
      {
        h: "1.1 Temel Kavramlar: Bilim, Kimya, Sanayi, Toplum",
        blocks: [
          { p: "__**Bilim (TDK):**__ Evrenin veya olayların bir bölümünü konu olarak seçen, deneye dayanan yöntemler ve gerçeklikten yararlanarak sonuç çıkarmaya çalışan düzenli bilgi; ilim. Ayrıca belli bir alanla ilgili olgu ve olaylar üzerine ortaya konulmuş sistemli ve düzenli bilgilerin bütünüdür." },
          { table: { head: ["Bilim Dalı", "İnceleme Alanı", "Örnekler"], rows: [
            ["Doğa (Fen) Bilimleri", "Doğal olaylar ve maddeyi deney-gözlemle inceler", "Fizik, Kimya, Biyoloji, Astronomi, Jeoloji"],
            ["Sosyal / Beşerî Bilimler", "İnsanı, toplumu ve insan ürünlerini inceler", "Sosyoloji, Tarih, Psikoloji, Ekonomi, Felsefe"],
          ] } },
          { p: "__**Kimya:**__ Maddenin yapısını, özelliklerini, bileşimini ve maddenin geçirdiği değişimleri (tepkimeleri) ve bu değişimlerdeki enerji alışverişini inceleyen bilim dalıdır." },
          { p: "__**Sanayi:**__ Ham maddeleri işleyerek ya da enerji kaynaklarını kullanarak ürün üreten etkinliklerin (endüstri) bütünü." },
          { p: "__**Toplum:**__ Aynı topraklar üzerinde yaşayan, ortak tarih, kültür ve değerlerle birbirine bağlı insanlar topluluğu." },
        ],
      },
      {
        h: "1.2 Teknoloji Kavramı ve Etimolojisi",
        blocks: [
          { p: "__**Teknoloji**__ sözcüğü Yunanca **tekhne** (sanat, zanaat, beceri) ve **logos** (bilgi, söz, bilim) kelimelerinden türemiştir: ==**\"bilgiden gelen zanaat\"**==." },
          { p: "**TDK tanımları:** (1) Bir sanayi dalı ile ilgili yapım yöntemlerini, kullanılan araç ve gereçleri, aletleri inceleyen bilim; uygulayım bilimi. (2) Bilimsel bilginin, insan hayatını kolaylaştırmak amacıyla pratik uygulamalara dönüştürülmesi; bu amaçla kullanılan araç, gereç ve yöntemlerin tamamı." },
          { box: "Teknoloji, bilim ve mühendislikten **önce** ortaya çıkmıştır. Kanıt: ==**Mısır Piramitleri**== — bilimsel kuramlar ve mühendislik disiplini oluşmadan önce yapılmış teknolojik başarılardır. İnsanı diğer canlılardan ayıran temel nitelik ==**alet yapma yeteneğidir**==.", tone: "exam" },
          { p: "==Bilim \"**neden?**\" sorusuna, teknoloji \"**nasıl?**\" sorusuna yanıt arar==. Bilim bilgi üretir; teknoloji bu bilgiyi ürün ve yönteme dönüştürür. Günümüzde ikisi birbirini besler (bilim → yeni teknoloji → yeni ölçüm aletleri → yeni bilim)." },
        ],
      },
      {
        h: "1.3 Bilimsel Bilgiden Ürün Geliştirmenin 4 Evresi",
        blocks: [
          { flow: ["1. Bilgiye ulaşma", "2. Ürün tasarlama", "3. Üretim tekniklerini belirleme", "4. Üretim"] },
          { ul: [
            "**Bilgiye ulaşma:** Bilimsel bilginin araştırılması, literatür ve deneysel verinin toplanması.",
            "**Ürün tasarlama:** İhtiyaca uygun ürünün tasarımı, prototip.",
            "**Üretim tekniklerini belirleme:** Ham madde, proses, ekipman ve yöntemin seçilmesi.",
            "**Üretim:** Ürünün endüstriyel ölçekte üretilmesi ve topluma sunulması.",
          ] },
        ],
      },
      {
        h: "1.4 Toplumların Evrimi: Toplum 1.0 → 4.0",
        blocks: [
          { table: { head: ["Toplum", "Dönem", "Temel Özellikler"], rows: [
            ["Toplum 1.0 – Avcı-Toplayıcı", "Tarih öncesi", "Avcılık, toplayıcılık, göçebe yaşam, doğa ile uyum; basit taş aletler."],
            ["Toplum 2.0 – Tarım Toplumu", "MÖ 13.000 – 18. yy ortası", "Yerleşik hayat, sulama, toprak mülkiyeti, tarım aletleri, köy-kent oluşumu."],
            ["Toplum 3.0 – Sanayi Toplumu", "==18. yy'ın üçüncü çeyreği, İngiltere==", "==James Watt buhar makinesi==, makineleşme, fabrikalar, kentleşme, seri üretim."],
            ["Toplum 4.0 – Bilgi Toplumu", "==20. yy'ın son çeyreği==", "Bilgi stratejik meta; bilgisayar-internet, yaşam boyu eğitim, bireyselleşme, hizmet sektörü."],
          ] } },
          { p: "**Freyer'e göre Sanayi Devrimi dalgaları:**" },
          { table: { head: ["Yıl", "Dalga"], rows: [
            ["1760", "Dokuma (tekstil) sanayii"],
            ["1800", "Demir-çelik sanayii"],
            ["1825", "Ulaştırma (demiryolu, buharlı gemi)"],
            ["1850", "Kimya çağı"],
            ["1900", "Elektrik ve benzin motoru"],
          ] } },
          { box: "Bilgi toplumunda **bilgi**, toprak ve sermayenin yerini alarak ==**stratejik meta (üretim faktörü)**== hâline gelir; ==**yaşam boyu eğitim**== ve ==**bireyselleşme**== öne çıkar.", tone: "info" },
        ],
      },
      {
        h: "1.5 Toplum 5.0 – Süper Akıllı Toplum",
        blocks: [
          { p: "Toplum 5.0, ==**Japonya**=='nın ortaya koyduğu bir vizyondur. Siber uzay ile fiziksel uzayın (yapay zekâ, IoT, büyük veri, robotik) yüksek düzeyde entegrasyonuyla ekonomik kalkınmayı sosyal sorunların çözümüyle dengeleyen ==**insan merkezli**== bir toplum modelidir." },
          { p: "Toplum 5.0, ==**BM Sürdürülebilir Kalkınma Amaçları (SKA)**== ile entegre edilmiştir. **10 temel başlık:**" },
          { ol: ["Şehirler ve Bölgeler", "Enerji", "Afet Önleme", "Sağlık", "Tarım ve Gıda", "Lojistik", "Üretim ve Hizmetler", "Finans", "Kamu Hizmeti", "İş birliği"] },
          { box: "**IUPAC vurgusu:** Kimya, Toplum 5.0 ve SKA'lara ulaşmada merkezi bir role sahiptir; IUPAC kimyanın sürdürülebilir kalkınmadaki (temiz enerji, temiz su, sağlık, gıda) katkısını vurgular.", tone: "exam" },
        ],
      },
    ],
  },
  {
    id: "u2",
    no: "Ünite 2",
    title: "Bilim ve Teknolojide Kimyanın Rolü",
    sections: [
      {
        h: "2.1 Merkezi Bilim Olarak Kimya",
        blocks: [
          { p: "Kimya, fizik ile biyoloji, yer bilimleri, tıp ve mühendislik arasında köprü kurduğu için ==**\"merkezi bilim\"**== olarak adlandırılır. Disiplinlerarası köprü örnekleri:" },
          { table: { head: ["Disiplin", "Kimyanın Köprü Rolü"], rows: [
            ["Biyokimya", "Canlılardaki kimyasal süreçler (enzimler, metabolizma, DNA)."],
            ["Fizikokimya", "Fizik ilkeleriyle kimyasal sistemler (termodinamik, kinetik, kuantum)."],
            ["Çevre Bilimi", "Kirleticilerin kaynağı, dönüşümü ve giderilmesi."],
            ["Kimya Mühendisliği", "Laboratuvar tepkimelerinin endüstriyel ölçeğe taşınması."],
          ] } },
        ],
      },
      {
        h: "2.2 Tıp ve İlaç",
        blocks: [
          { ul: [
            "**Yapı-aktivite ilişkileri (SAR):** Molekülün yapısı ile biyolojik etkinliği arasındaki ilişki; ilaç tasarımında temel.",
            "**Aktif Farmasötik Bileşen (AFB / API):** İlacın tedavi edici etkisini sağlayan etken madde; çok basamaklı organik sentezle üretilir.",
            "__**Asimetrik sentez:**__ Kiral moleküllerin ==**tek bir enantiyomerinin**== yüksek ==**stereoseçicilikle**== elde edilmesi (bir enantiyomer tedavi edici, diğeri etkisiz/zararlı olabilir).",
            "__**Katı faz sentezi:**__ Başlangıç molekülünün bir **reçine/katı desteğe bağlanarak** ardışık tepkimelerle büyütülmesi; yıkama ile kolay saflaştırma. En bilinen uygulaması ==**peptit sentezi**==dir.",
            "__**Farmakokinetik:**__ ==Vücudun ilaca ne yaptığı== (emilim, dağılım, metabolizma, atılım – ADME).",
            "__**Farmakodinamik:**__ ==İlacın vücuda ne yaptığı== (reseptöre bağlanma, etki mekanizması, doz-yanıt).",
            "**Terapötik:** Hastalığın tedavisine yönelik, iyileştirici (ilaç, tedavi yöntemi).",
            "**Nanopartiküllerle hedefe yönelik ilaç dağıtımı:** İlacın yalnızca hedef doku/hücreye (ör. tümör) taşınması, yan etkilerin azaltılması.",
            "**Aşılar:** Antijen, adjuvan ve stabilizatörlerin kimyasal formülasyonu (ör. mRNA aşılarında lipit nanopartiküller).",
          ] },
        ],
      },
      {
        h: "2.3 Tarım ve Gıda",
        blocks: [
          { ul: [
            "**NPK gübreleri:** Azot (N), Fosfor (P), Potasyum (K) içeren temel bitki besinleri.",
            "__**Haber-Bosch yöntemi:**__ Azot ve hidrojenden yüksek basınç-sıcaklık ve demir katalizörü ile ==**amonyak sentezi**==: N₂ + 3H₂ ⇌ 2NH₃. Azotlu gübre üretiminin temelidir.",
            "**Pestisitler:** ==Herbisit (**yabani ot** öldürücü)==, İnsektisit (böcek öldürücü), Fungisit (mantar öldürücü).",
            "**Tarımda yeşil kimya:** Daha az toksik, biyobozunur tarım kimyasalları; kontrollü salımlı gübreler.",
            "**GDO'lar:** Genetiği değiştirilmiş organizmalar; zararlılara/kuraklığa dayanıklı ürünler.",
          ] },
        ],
      },
      {
        h: "2.4 Malzeme Bilimi",
        blocks: [
          { table: { head: ["Malzeme", "Açıklama / Örnek"], rows: [
            ["Polimerler", "Monomerlerin tekrarlanan birimleri; plastikler, lifler, kauçuklar."],
            ["Kompozitler", "İki ya da daha fazla malzemenin birleşimi; ==**elyaf takviyeli polimerler**== (cam/karbon elyaf)."],
            ["Nanomalzemeler", "1-100 nm boyutlu; yüksek yüzey alanı, farklı optik/elektriksel özellik."],
            ["Akıllı malzemeler", "Uyarana yanıt veren: ==**şekil hafızalı alaşımlar**== (ısıtınca ilk şekle döner) ve ==**piezoelektrik malzemeler**== (mekanik basınç ↔ elektrik)."],
            ["Biyomalzemeler", "Vücutla uyumlu; implant, protez, doku iskelesi."],
          ] } },
        ],
      },
      {
        h: "2.5 Çevre ve Enerji",
        blocks: [
          { p: "**Kirlilik kontrolü:** Kirleticilerin **GC (gaz kromatografisi)** ve **MS (kütle spektrometrisi)** ile analizi; atık suda **biyolojik arıtma** ve **kimyasal oksidasyon**; araçlarda ==**katalitik konvertörler**== (CO, NOx, hidrokarbonları zararsız gazlara çevirir); endüstride **yıkayıcılar (scrubber)** baca gazındaki kirleticileri tutar." },
          { p: "**Yeşil kimya temel ilkeleri:** Atığı önleme, **güvenli/su bazlı çözücüler**, **enerji verimliliği** (oda sıcaklığı-basıncında tepkime), **yenilenebilir hammaddeler**, katalizör kullanımı, biyobozunur ürün tasarımı." },
          { table: { head: ["Enerji Üretimi", "Enerji Depolama"], rows: [
            ["**Silikon fotovoltaik** güneş hücreleri", "**Lityum-iyon piller** (taşınabilir cihaz, elektrikli araç)"],
            ["**Biyoyakıtlar:** etanol ve biyodizel", "**Akış pilleri:** sıvı elektrolitli, büyük ölçekli depolama"],
            ["**Suyun elektrolizi ile hidrojen** üretimi", "==**Süperkapasitörler:**== yükü ==**elektrostatik**== depolar, hızlı şarj-deşarj"],
          ] } },
        ],
      },
      {
        h: "2.6 Analitik Teknikler ve Tüketici Ürünleri",
        blocks: [
          { table: { head: ["Teknik", "Kullanım"], rows: [
            ["Kromatografi (GC, HPLC)", "Karışım bileşenlerinin ayrılması ve miktar tayini."],
            ["Spektroskopi (MS, NMR)", "MS: kütle/yük oranı ile tanımlama; NMR: molekül yapısının aydınlatılması."],
            ["Elektrokimyasal analiz", "==**Potansiyometri**== (pH metre, iyon seçici elektrot) ve **voltammetri**."],
            ["LC-MS/MS", "Sıvı kromatografi + ardışık kütle spektrometrisi; eser düzeyde ilaç, kalıntı analizi."],
          ] } },
          { ul: [
            "**Cilt bakımı:** Hyaluronik asit (nem tutucu), niasinamid (B3 vitamini; bariyer, leke).",
            "**Saç bakımı:** Yüzey aktif maddeler (şampuanlarda temizleyici), emülgatörler (yağ-su karışımını kararlı kılar).",
            "**Dezenfektanlar:** Kuaterner amonyum bileşikleri (QAC).",
            "**Gıda katkıları:** Sodyum benzoat (koruyucu), MSG – monosodyum glutamat (==**umami**== tat artırıcı), renklendiriciler.",
          ] },
        ],
      },
    ],
  },
  {
    id: "u3",
    no: "Ünite 3",
    title: "Su Teknolojisi, Su Sertliği ve Su Arıtma",
    sections: [
      {
        h: "3.1 Su Teknolojisi ve Su Döngüsü",
        blocks: [
          { p: "Su teknolojisinin ==**3 ana konusu:**== (1) İçme ve kullanma suyunun hazırlanması (su tasfiyesi), (2) Endüstriyel (kazan, soğutma, proses) suların hazırlanması, (3) Atık suların arıtılması." },
          { ul: [
            "**Su döngüsü:** Buharlaşma → yoğunlaşma → yağış → yüzeysel akış → sızma (infiltrasyon) → yeraltı akışı.",
            "__**Transpirasyon:**__ Bitkilerin yapraklarından su buharı vermesi (terleme).",
            "__**Sızma (infiltrasyon):**__ Yağış suyunun toprak gözeneklerinden aşağı süzülmesi.",
            "__**Akifer:**__ Suyu depolayan ve ileten, geçirgen yeraltı kayaç/tortu tabakası (yeraltı su haznesi).",
          ] },
        ],
      },
      {
        h: "3.2 Gazların Sudaki Çözünürlüğü ve Doğal Suların Bileşimi",
        blocks: [
          { p: "__**Henry-Dalton kanunu:**__ Bir gazın sudaki çözünürlüğü, o gazın su üzerindeki ==**kısmi basıncıyla doğru orantılıdır**==; ==sıcaklık arttıkça gazların çözünürlüğü **azalır**==." },
          { table: { head: ["Sıcaklık", "N₂", "O₂", "CO₂"], rows: [
            ["0 °C", "En yüksek", "En yüksek (~14,6 mg/L)", "En yüksek"],
            ["10 °C", "Azalır", "~11,3 mg/L", "Azalır"],
            ["20 °C", "En düşük", "~9,1 mg/L", "En düşük"],
          ] } },
          { box: "0 °C'den 20 °C'ye ısınınca N₂, O₂ ve CO₂'nin **üçünün de** çözünürlüğü azalır. ==CO₂ en çok çözünen gazdır==.", tone: "info" },
          { p: "Yağmur suyu havadan CO₂ alır; toprağın alt tabakalarına sızan **CO₂'ce zengin su**, kireç taşını (CaCO₃) ve Fe, Mn bileşiklerini ==**bikarbonat (HCO₃⁻)**== hâlinde çözer:" },
          { formula: ["CaCO₃ + CO₂ + H₂O ⇌ Ca(HCO₃)₂", "MgCO₃ + CO₂ + H₂O ⇌ Mg(HCO₃)₂"] },
          { p: "Su, ==**jips (alçı taşı, CaSO₄·2H₂O)**== tabakalarından geçerken sülfatı çözer → kalıcı sertlik." },
          { table: { head: ["Özellik", "Akarsu (yüzey suyu)", "Yeraltı suyu"], rows: [
            ["Çözünmüş tuz", "Az", "Çok (kayaçlarla uzun temas)"],
            ["Bulanıklık", "Fazla (askıda kil, organik madde)", "Az / berrak (toprak süzer)"],
            ["Sertlik", "Düşük", "Yüksek"],
            ["Mikrobiyolojik kirlilik", "Yüksek", "Düşük"],
          ] } },
        ],
      },
      {
        h: "3.3 Su Sertliği Birimleri (HESAPLAMA)",
        blocks: [
          { p: "Su sertliği, suda çözünmüş başta ==**Ca²⁺ ve Mg²⁺**== olmak üzere çok değerlikli metal iyonlarının toplam derişimidir." },
          { formula: [
            "1 Alman Sertlik Derecesi (1 AS°) = 10 mg CaO / 1 L su",
            "1 Fransız Sertlik Derecesi (1 FS°) = 10 mg CaCO₃ / 1 L su",
            "1 İngiliz Sertlik Derecesi (1 İS°) = 10 mg CaCO₃ / 0,7 L su = 14,3 mg CaCO₃ / 1 L su",
            "1 ppm = 1 mg tuz (CaCO₃) / 1 L su",
          ] },
          { p: "**Mol kütleleri (g/mol):** CaO = 56, CaCO₃ = 100, MgO = 40, MgCO₃ = 84, Ca = 40, Mg = 24, Ca(HCO₃)₂ = 162, Mg(HCO₃)₂ = 146, CaSO₄ = 136, MgSO₄ = 120." },
          { formula: [
            "1 AS° = 1,79 FS°   (10 mg CaO = 10/56 mmol → ×100 = 17,86 mg CaCO₃)",
            "1 FS° = 0,56 AS°   (10 mg CaCO₃ = 0,1 mmol → ×56 = 5,6 mg CaO)",
            "1 İS° = 1,43 FS°   (14,3 mg CaCO₃ / 10)",
            "1 İS° = 0,8 AS°",
          ] },
          { box: "__**Altın kural (eşdeğerlik):**__ Her sertlik yapan bileşikteki ==1 mol Ca²⁺ veya Mg²⁺==, ==**1 mol CaO**== veya ==**1 mol CaCO₃**== sertliğine eşdeğerdir.\n• CaO eşdeğeri (mg) = (madde mg / M) × 56 → AS° = CaO eşdeğeri / 10\n• CaCO₃ eşdeğeri (mg) = (madde mg / M) × 100 → FS° = CaCO₃ eş. / 10; İS° = CaCO₃ eş. / 14,3; ppm = CaCO₃ eş.", tone: "exam" },
          { p: "**Pratik çarpanlar:** ==Ca²⁺ → CaCO₃ için ×2,5== ; ==Mg²⁺ → CaCO₃ için ×4,17== ; ==Ca²⁺ → CaO için ×1,4== ; Mg²⁺ → CaO için ×2,33 ; MgO → CaO için ×1,4." },
          { p: "**Çözümlü örnek:** 1 L suda 80 mg Ca²⁺ ve 24 mg Mg²⁺ var. Ca: 80/40 = 2 mmol; Mg: 24/24 = 1 mmol → toplam 3 mmol. CaCO₃ eş. = 3 × 100 = 300 mg → **30 FS°**, İS° = 300/14,3 = **21 İS°**, CaO eş. = 3 × 56 = 168 mg → **16,8 AS°** (oldukça sert), ppm = **300** (WHO: çok sert)." },
        ],
      },
      {
        h: "3.4 Sertlik Sınıflandırması ve Sertlik Türleri",
        blocks: [
          { table: { head: ["AS°", "Sınıf"], rows: [
            ["0 – 4", "Çok yumuşak"], ["4 – 8", "Yumuşak"], ["8 – 12", "Biraz sert"], ["12 – 18", "Oldukça sert"], ["18 – 30", "Sert"], ["> 30", "Çok sert"],
          ] } },
          { table: { head: ["WHO (mg/L CaCO₃)", "Sınıf"], rows: [
            ["0 – 75", "Yumuşak"], ["75 – 150", "Orta sert"], ["150 – 300", "Sert"], ["≥ 300", "Çok sert"],
          ] } },
          { ul: [
            "__**Geçici sertlik (bikarbonat / karbonat sertliği):**__ Ca(HCO₃)₂ ve Mg(HCO₃)₂'den kaynaklanır. Su **ısıtılınca** CaCO₃ ve MgCO₃ ==**kazan taşı**== olarak çöker ve giderilir: Ca(HCO₃)₂ → CaCO₃↓ + CO₂ + H₂O.",
            "__**Kalıcı sertlik:**__ Ca ve Mg'nin ==**sülfat, klorür, nitrat, silikat**== tuzlarından kaynaklanır; kaynatmakla giderilemez (iyon değişimi vb. gerekir).",
            "==**Toplam sertlik = Geçici sertlik + Kalıcı sertlik.**==",
          ] },
        ],
      },
      {
        h: "3.5 Şehir Suyu Özellikleri – TS 266 İçme Suyu Standartları",
        blocks: [
          { table: { head: ["Parametre", "Değer"], rows: [
            ["İdeal sıcaklık", "==7 – 10 °C=="],
            ["TS 266 sıcaklık", "Tavsiye 12 °C / maksimum 25 °C"],
            ["pH", "==6,5 – 8,5 (maksimum 9,2)=="],
            ["Toplam tuz", "==Maksimum 600 mg/L=="],
            ["H₂S", "Bulunmamalı (çürük yumurta kokusu)"],
            ["Fe ve Mn", "Çamaşırda/tesisatta leke ve kötü tat yapar"],
          ] } },
          { p: "İçme suyu renksiz, kokusuz, berrak, hoş tatlı ve mikroorganizmalardan arınmış olmalıdır." },
        ],
      },
      {
        h: "3.6 Su Tasfiyesi Akım Şeması",
        blocks: [
          { flow: ["Nehir", "Izgara", "Biriktirme", "Ön Klorlama (Cl₂)", "Hızlı Karıştırma", "pH Kontrolü", "Yumaklaştırma (30-45 dk)", "Çöktürme (2-4 saat)", "Filtrasyon", "Son Klorlama (Cl₂)", "Ana Depo"] },
          { ul: [
            "**Izgara:** Kaba yüzen maddeleri (dal, yaprak, çöp) tutar.",
            "**Ön klorlama:** Alg ve mikroorganizma büyümesini, organik maddeyi kontrol eder.",
            "**Hızlı karıştırma:** Koagülantın suya homojen dağılması.",
            "__**Yumaklaştırma (koagülasyon-flokülasyon, ==30-45 dk==):**__ ==**≤ 1 µm**== boyutundaki kolloidlerin yük nötralizasyonu ile büyük yumaklar (flok) oluşturması. Kimyasallar: ==**Al₂(SO₄)₃**== (alüm), **FeSO₄**, **NaAlO₂**, **FeCl₃**, **CaO**.",
            "__**Çöktürme (==2-4 saat==):**__ Yumakların çökeltme havuzunda dibe çökmesi.",
            "**Filtrasyon:** Kalan askıdaki partiküllerin kum filtrelerde tutulması.",
            "**Son klorlama:** Şebekede kalıcı (bakiye) dezenfektan sağlanması.",
          ] },
        ],
      },
      {
        h: "3.7 Filtrasyon: Hızlı ve Yavaş Kum Filtreleri",
        blocks: [
          { table: { head: ["Özellik", "Hızlı Filtrasyon", "Yavaş Kum Filtrasyonu"], rows: [
            ["Mekanizma", "==**Fiziksel**==", "==**Biyolojik**=="],
            ["Dane boyu", "0,5 – 3 mm kum / antrasit", "0,3 – 0,5 mm ince kum"],
            ["Tutma yeri", "Derinlikte tutma", "Yüzeyde \"==**kirli deri**==\" (schmutzdecke) tabakası"],
            ["Hız", "Yüksek", "Hızlı filtrenin ==~**1/100**=='ü"],
            ["Temizleme", "==**Ters akışla geri yıkama**==", "Üst tabakanın kazınması"],
          ] } },
        ],
      },
      {
        h: "3.8 Dezenfeksiyon: Serbest ve Bağlı Klor",
        blocks: [
          { formula: ["Cl₂ + H₂O ⇌ HOCl + HCl", "HOCl ⇌ H⁺ + OCl⁻"] },
          { p: "__**Serbest klor:**__ Cl₂, ==HOCl (hipokloröz asit, en etkili)== ve OCl⁻ (hipoklorit). ==**NaCl'deki Cl⁻ iyonu dezenfektan değildir!**==" },
          { p: "__**Bağlı klor (kloraminler):**__ Amonyak + HOCl tepkimesiyle oluşur:" },
          { formula: ["NH₃ + HOCl → NH₂Cl (monokloramin) + H₂O", "NH₂Cl + HOCl → NHCl₂ (dikloramin) + H₂O", "NHCl₂ + HOCl → NCl₃ (trikloramin) + H₂O"] },
          { box: "Kloraminler arasında ==**tat problemi yapmayan**== ve dezenfeksiyonda ==**en kuvvetli**== olan ==**monokloramin (NH₂Cl)**== tercih edilir. Di- ve trikloramin koku/tat sorunu yapar.", tone: "exam" },
        ],
      },
      {
        h: "3.9 Havalandırma, Aktif Karbon, Oksidasyon, İyon Değişimi",
        blocks: [
          { ul: [
            "**Havalandırma:** CO₂, H₂S ve uçucu tat-koku maddelerinin uzaklaştırılması, Fe²⁺ oksidasyonu için O₂ sağlanması.",
            "**Aktif karbon adsorpsiyonu:** Organik maddeler, tat-koku, renk ve pestisitlerin yüzeye tutunarak giderilmesi.",
            "**Demir giderimi (oksidasyon):** Fe²⁺ → Fe³⁺ → ==**Fe(OH)₃**== çökeltisi → filtrasyonla uzaklaştırma.",
            "**Mangan giderimi:** ==**KMnO₄, O₃, Cl₂, ClO₂**== gibi kuvvetli oksitleyicilerle MnO₂ olarak çöktürme.",
          ] },
          { table: { head: ["İyon Değiştirici", "Tuttuğu İyonlar", "Verdiği İyon", "Rejenerasyon"], rows: [
            ["**Katyon reçinesi**", "Ca²⁺, Mg²⁺, Ba²⁺, Ra²⁺", "Na⁺", "NaCl (==tansiyon hastaları için **KCl**==)"],
            ["**Anyon reçinesi**", "NO₃⁻, arsenat, selenat, kromat, uranil karbonat, perklorat", "Cl⁻", "NaCl"],
          ] } },
          { formula: ["2 R–Na + Ca²⁺ → R₂Ca + 2 Na⁺   (yumuşatma)", "R₂Ca + 2 NaCl → 2 R–Na + CaCl₂   (rejenerasyon)"] },
        ],
      },
    ],
  },
  {
    id: "u4",
    no: "Ünite 4",
    title: "Odunun Kimyasal İşlenmesi ve Kağıt Teknolojisi",
    sections: [
      {
        h: "4.1 Hammadde, Kağıt Türleri ve Odunun Bileşenleri",
        blocks: [
          { p: "**Kağıt türleri:** Yazı-baskı kağıtları, temizlik (hijyenik) kağıtları, gazete kağıdı, ambalaj kağıtları, karton, mukavva ve özel kağıtlar (filtre, sigara, banknot vb.)." },
          { table: { head: ["Bileşen", "Görev"], rows: [
            ["Selüloz", "Doğrusal glukoz polimeri; kağıdın lifini ve mukavemetini oluşturur."],
            ["Hemiselüloz", "Dallanmış kısa zincirli polisakkarit; lifler arası bağlanmaya katkı."],
            ["Lignin", "Lifleri bir arada tutan aromatik \"yapıştırıcı\" polimer; sararmaya neden olur."],
            ["Ekstraktlar", "Reçine, yağ asitleri, terpenler (tall yağı, terebentin kaynağı)."],
          ] } },
          { p: "__**Delignifikasyon:**__ Ligninin kimyasal yolla çözünüp liflerden uzaklaştırılması. __**Kappa sayısı:**__ Hamurda kalan lignin miktarının ölçüsüdür; ağartma sonrası ==**< 1**== olur." },
        ],
      },
      {
        h: "4.2 Kraft (Sülfat) Prosesi",
        blocks: [
          { ul: [
            "Dünya kimyasal hamur üretiminin ==**~%80**=='i; ==**yüksek mukavemetli**== hamur verir; dezavantajı ==**koku problemi**== (indirgenmiş kükürt bileşikleri – merkaptanlar, H₂S).",
            "Kayıpları telafi etmek için sisteme ==**Na₂SO₄**== eklendiğinden **\"sülfat prosesi\"** de denir.",
            "__**Beyaz likör:**__ ==NaOH + Na₂S (pH 13-14)== — pişirme kimyasalı.",
            "__**Siyah likör:**__ Pişirme sonrası çözünmüş lignin + kullanılmış kimyasallar. ==**Zayıf siyah likör (%14-18 katı)**== → buharlaştırma → ==**konsantre siyah likör (%65-80 katı)**== → **Soda kazanında** yakılır: enerji + kimyasal geri kazanımı (==**~%99**==).",
            "__**Yeşil likör:**__ Soda kazanı eriyiğinin suda çözülmesiyle: ==**Na₂CO₃ + Na₂S**==.",
            "__**Kalsiyum (kireç) döngüsü:**__ Yeşil likör **CaO** ile kostikleştirilir → beyaz likör (NaOH) + ==**CaCO₃ (kireç çamuru)**==; kireç çamuru kireç fırınında yakılarak tekrar **CaO** elde edilir.",
          ] },
          { formula: ["Na₂CO₃ + Ca(OH)₂ → 2 NaOH + CaCO₃↓   (kostikleştirme)", "CaCO₃ → CaO + CO₂   (kireç fırını)", "CaO + H₂O → Ca(OH)₂   (söndürme)"] },
          { flow: ["Beyaz likör (NaOH+Na₂S)", "Pişirme", "Zayıf siyah likör %14-18", "Buharlaştırma", "Konsantre siyah likör %65-80", "Soda kazanı", "Yeşil likör (Na₂CO₃+Na₂S)", "Kostikleştirme (CaO)", "Beyaz likör"] },
          { p: "__**Oksijenli delignifikasyon:**__ 90-100 °C, basınç altında, ==**oksitlenmiş beyaz likör (NaOH + Na₂S₂O₃)**== ile yapılır; selüloz zincirlerinin parçalanmasını önleyip ==**mukavemeti korumak için MgSO₄**== eklenir." },
          { p: "**Ağartma:** Esmer selüloz (< %30 ISO beyazlık) → tam ağartılmış (==**%88 ISO**==). Ajanlar: ==**ClO₂, O₂, H₂O₂, O₃, perasetik asit**==. **Kurutma:** Entegre olmayan tesiste hamur kurutulur; **entegre tesiste ~%4 su içeriğine** kadar kurutma kağıt makinesinde yapılır." },
          { p: "**Yan ürünler:** Siyah likörden ayrılan ==**tall yağı sabunu**== asitlendirilerek **ham tall yağı** elde edilir; pişirme gazlarından ==**ham sülfat terebentini**== kazanılır." },
        ],
      },
      {
        h: "4.3 Sülfit Prosesi",
        blocks: [
          { p: "Pişirme kimyasalı **SO₂ + baz** (Mg²⁺, Ca²⁺, Na⁺, NH₄⁺); ==**aktif bileşen HSO₃⁻ (bisülfit)**==." },
          { table: { head: ["Proses", "pH", "Ürün / Not"], rows: [
            ["Asit bisülfit", "1 – 2,5", "Kağıt hamuru, çözünmüş selüloz"],
            ["Bisülfit (Magnefit)", "3 – 5", "Mg bazlı; kağıt hamuru"],
            ["Nötr sülfit (NSSC – yarı kimyasal)", "5 – 7", "==**%75-90 verim**==, ==**oluklu mukavva**== (fluting)"],
            ["Çözünmüş selüloz", "Asidik", "==**Tekstil – viskoz**== lif"],
            ["İhtisas selülozu", "—", "Selüloz eterler, selüloz esterler, mikrokristalin selüloz"],
          ] } },
          { box: "**Ca²⁺** en ucuz bazdır; ancak kimyasal ==**geri dönüşümü engeller**== ve **CaSO₃ kireçlenmesi (taş)** yapar. Çözünürlük için ==**pH ~1,5**== tutulmalıdır.", tone: "exam" },
          { ul: [
            "__**ECF (Elemental Chlorine Free):**__ ==Moleküler **Cl₂ kullanılmaz**== (ClO₂ kullanılabilir).",
            "__**TCF (Totally Chlorine Free):**__ ==**Hiç klor bileşiği** kullanılmaz== (O₂, O₃, H₂O₂, perasetik asit).",
            "**Atık Sülfit Likörü (ASL) – Biyorafineri yan ürünleri:** Linyosülfonatlar (beton katkısı, bağlayıcı), etanol, ==**vanilya (vanilin)**==, hayvan yemi mayası, furfural, asetik asit.",
          ] },
        ],
      },
      {
        h: "4.4 Mekanik ve Yarı Kimyasal Hamur Yöntemleri",
        blocks: [
          { table: { head: ["Yöntem", "Açıklama"], rows: [
            ["GW (Taşlama odun hamuru)", "Odun kütükleri döner taşa bastırılarak liflenir."],
            ["PGW (Basınçlı taşlama)", "Basınç altında taşlama; daha uzun lif, mukavemet."],
            ["TMP (Termomekanik hamur)", "Yonga ==**ön ısıtma**== (buhar) sonrası ==**rifaynır (merdane/disk)**== ile liflendirme."],
            ["CMP (Kimyasal-mekanik)", "Kimyasal emprenye + mekanik liflendirme."],
            ["CTMP (Kimyasal-termomekanik)", "Kimyasal emprenye + ön ısıtma + rifaynır; ==**rifaynır enerjisini %10-20 düşürür**==. Yumuşak ağaçta **Na₂SO₃**, sert ağaçta **NaOH + H₂O₂**."],
          ] } },
          { box: "Mekanik hamur ağartmasında ==**lignin uzaklaştırılmaz**==, yalnızca ==**kromoforlar renksizleştirilir**== (ağartma ==**kalıcı değildir**==, ışıkla sararır — gazete kağıdı).", tone: "exam" },
          { ul: [
            "__**İndirgen ağartma:**__ ==**Sodyum ditionit (Na₂S₂O₄)**== → ==**%10-12**== beyazlık artışı.",
            "__**Oksidatif ağartma:**__ **H₂O₂** → ==**%20-40**== beyazlık artışı. Metal iyonları H₂O₂'yi bozduğundan ==**EDTA/DTPA şelasyon ajanları**== ve stabilizatör **Na₂SiO₃** kullanılır. NaOH yerine **Ca(OH)₂** kullanılması ==**KOİ'yi ~%30**== düşürür.",
          ] },
        ],
      },
      {
        h: "4.5 Kağıt Geri Dönüşümü",
        blocks: [
          { flow: ["Pulper (hamurlaştırma)", "Hidrosiklon (ağır kirlilik)", "Flotasyon (10-250 µm mürekkep)", "Yıkama (<10 µm mürekkep, kül)"] },
          { ul: [
            "**Pulper:** Atık kağıdın su ile karıştırılıp liflere ayrıştırılması.",
            "**Hidrosiklon:** Merkezkaç kuvvetiyle kum, zımba teli gibi ağır kirliliklerin ayrılması.",
            "**Flotasyon:** ==**10-250 µm**== mürekkep partiküllerinin **sabun / yağ asidi** ile hava kabarcıklarına tutturularak yüzdürülmesi (mürekkep giderme – deinking).",
            "**Yıkama:** ==**< 10 µm**== küçük mürekkep partikülleri ve kül (dolgu) giderimi.",
          ] },
        ],
      },
      {
        h: "4.6 Kağıt Makinesi ve Yardımcı İşletmeler",
        blocks: [
          { flow: ["Hamur kasası (%0,2-1,5)", "Bantlı elek (%12-20)", "Pres (%50)", "Kurutma (buharlı silindir)", "Kalender (perdah)", "Bobin sarma"] },
          { table: { head: ["Bölüm", "Kuru Madde", "Not"], rows: [
            ["Hamur kasası (headbox)", "==%0,2 – 1,5==", "Seyreltik süspansiyonu elek üzerine eşit yayar."],
            ["Bantlı elek bölümü", "İlk 10 m'de %10-20; genel %12-20", "Su yerçekimi ve vakumla süzülür, tabaka oluşur."],
            ["Pres bölümü", "==~%50==", "Keçeler ve merdanelerle mekanik su uzaklaştırma."],
            ["Kurutma bölümü", "==~%90-95==", "Buharla ısıtılan silindirler."],
            ["Kalenderleme", "—", "Perdahlama: düzgünlük, parlaklık, kalınlık kontrolü."],
          ] } },
          { p: "**Yardımcı kimyasallar (Tablo 3):** Dolgu maddeleri (kaolen, CaCO₃, TiO₂ — opaklık, beyazlık), tutkallama (AKD, ASA, reçine — su direnci), kuru mukavemet (nişasta), ıslak mukavemet reçineleri, **PFC/PFPE** (yağ-su geçirmezlik), retensiyon yardımcıları, köpük kesiciler, boyalar/optik ağartıcılar, **biyositler** (mikrobiyal birikimi önler)." },
          { ul: [
            "__**Kazan blöf suları:**__ Buhar kazanında biriken çözünmüş tuzların derişimini sınırlamak için kazandan periyodik su boşaltılması.",
            "__**Kojenerasyon (CHP):**__ Elektrik ve ısının (buhar) ==**aynı anda**== üretilmesi; yüksek enerji verimi.",
            "**Soğutma sistemleri:** **Tek geçişli** (su bir kez kullanılır ve deşarj edilir), **açık devre** (soğutma kulesi; buharlaşmayla soğuma, sirkülasyon), ==**kapalı devre**== (su kapalı döngüde, ısı eşanjörle atılır; en az su kaybı).",
          ] },
        ],
      },
    ],
  },
];
